/** API route map: URLS.Controller.CandidateJob */
export const CandidateJob = {
      Name: 'CandidateJob/',
      Add: 'add',
      DeleteMultiple: 'delete-jobs',
      DeleteSingle: 'delete-job',
      Get: 'get-jobs',
};
